import React, { useState, useImperativeHandle } from 'react';
import './BottomMenu.css';
import ProjectsPopup from './ProjectsPopup';
import useProjectsManager from './ProjectsManager';
import Popup from '../UI/Popup';
import LoadingButton from '../UI/LoadingButton';

const BottomMenu = React.forwardRef(({ onProjectSelected, onNewProject, isNewProject, selectedProject, onOpenPricing, onOpenSettings, onOpenGenerator, selected }, ref) => {
    const [showProjectsPopup, setShowProjectsPopup] = useState(false);

    const {
        projects,
        currentProject,
        setCurrentProject,
        showProjectDeletePopup,
        displayDeletePopup,
        setDisplayDeletePopup,
        deleteProjectData,
        isDeleting,
        handleDeleteProject,
        refreshProjects,
    } = useProjectsManager({ onProjectSelected, onNewProject });

    useImperativeHandle(ref, () => ({
        refreshProjects,
    }));

    return (
        <>
            <div className="bottom-menu">
            <button
                    className={`button-bottommenu`}
                    onClick={onNewProject}
                >
                    <span className="material-symbols-outlined icon">add_circle</span>
                </button>
                <button
                    className={`button-bottommenu ${selected === 'projects' ? 'active' : ''}`}
                    onClick={() => setShowProjectsPopup(true)}
                >
                    <span className="material-symbols-outlined icon">folder</span>
                </button>
                <button
                    className={`button-bottommenu ${selected === 'generator' ? 'active' : ''}`}
                    onClick={onOpenGenerator}
                >
                    <span className="material-symbols-outlined icon">book_4_spark</span>
                </button>


                
                <button
                    className={`button-bottommenu ${selected === 'settings' ? 'active' : ''}`}
                    onClick={onOpenSettings}
                >
                    <span className="material-symbols-outlined icon">settings</span>
                </button>
            </div>

            {showProjectsPopup && (
                <ProjectsPopup
                    projects={projects}
                    currentProject={currentProject}
                    onClose={() => setShowProjectsPopup(false)}
                    onProjectSelected={(projectId) => {
                        setCurrentProject(projectId);
                        setShowProjectsPopup(false);
                        onProjectSelected(projectId);
                    }}
                    onDeleteProject={showProjectDeletePopup}
                />
            )}

            {displayDeletePopup && (
                <Popup
                    title="Delete project"
                    onClose={() => setDisplayDeletePopup(false)}
                >
                    <div className="">
                        <p>Do you really want to delete the project {deleteProjectData.name}?</p>

                        <div className="popup-buttons">
                            <button
                                className="button-hollow"
                                onClick={() => setDisplayDeletePopup(false)}
                            >
                                Cancel
                            </button>
                            <LoadingButton
                                className="button-plain"
                                onClick={handleDeleteProject}
                                isLoading={isDeleting}
                            >
                                Delete
                            </LoadingButton>
                        </div>
                    </div>
                </Popup>
            )}
        </>
    );
});

export default BottomMenu;
